module.exports = __webpack_public_path__ + "img/stock5.3b620ee3.png";